"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSearchPreviewDialog = exports.SearchWithBackButtonContainer = exports.SearchPreviewRoot = exports.SearchPreviewContent = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const SearchPreviewRoot = exports.SearchPreviewRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  background: theme.palette.common.white,
  boxSizing: 'border-box',
  color: theme.palette.text.primary,
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    position: 'static',
    padding: 0,
    height: '100%'
  }
}));
const SearchPreviewContent = exports.SearchPreviewContent = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  width: '100%',
  height: '100%',
  gap: theme.spacing(6)
}));
const StyledSearchPreviewDialog = exports.StyledSearchPreviewDialog = (0, _mui.styled)(_components.Dialog, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['isTopBannerVisible', 'position', 'showOnlyOn'])
})(({
  isTopBannerVisible,
  theme,
  position,
  showOnlyOn
}) => ({
  display: showOnlyOn === 'mobile' ? 'flex' : 'none',
  [`.${_components.dialogClasses.dialogGrid}`]: {
    width: '100%',
    height: '100dvh',
    maxHeight: '100dvh',
    borderRadius: 0,
    [`.${_mui.scopedCssBaselineClasses.root}`]: {
      padding: theme.spacing(3, 3, 0, 3)
    },
    gridTemplateAreas: `
      "header header header"
      "content content content"
      "footer footer footer"
    `
  },
  [theme.breakpoints.up('md')]: {
    display: showOnlyOn === 'desktop' ? 'flex' : 'none',
    alignItems: 'flex-start',
    top: isTopBannerVisible ? _presentationUtils.TOP_AREA_BANNER_HEIGHT : 0,
    [`.${_components.dialogClasses.dialogGrid}`]: {
      width: `calc(100% - ${theme.spacing(16)})`,
      borderRadius: theme.spacing(2),
      height: 'auto',
      minHeight: 624,
      [`.${_mui.scopedCssBaselineClasses.root}`]: {
        padding: theme.spacing(6, 4, 0, 6)
      }
    }
  },
  [theme.breakpoints.up('lg')]: {
    ...(position.left !== 0 ? {
      left: position.left,
      justifyContent: 'flex-start'
    } : {})
  }
}));
const SearchWithBackButtonContainer = exports.SearchWithBackButtonContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  width: '100%',
  justifyContent: 'center'
}));
